export default "__VITE_ASSET__CyAECi$8__"